import React from "react";
import { FormHelperText } from "@mui/material";

export const HelperTextWrapper = (errorMessage: string) =>
  <FormHelperText
    sx={{
      color: "red",
      fontFamily: "Manrope",
      fontSize: "11px",
      whiteSpace: "pre-wrap",
      overflow: "hidden",
      width: "240px",

      "&.MuiFormHelperText-root": {
        margin: "0px",
        marginLeft: "-11px",
        color: "red",
      },
    }}
  >
    {errorMessage}
  </FormHelperText>
